import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HOME_PATH } from '../../constant/Constant';
import CheckBox from '../../component/CheckBox';
import { actionUserInfoWithdrawal } from '../../module/body/main/UserInfoModule';
import PopupRef from '../../component/PopupRef';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import { RedBgButtonBox } from '../../component/buttons/CustomButtonBox';
import SessionStorageUtil from '../../util/SessionStorageUtil';

const UserWithdrawalModal = ({ modalRef, userId, callback }) => {
    const [checked, setChecked] = useState(false);
    const popupRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const semesterId = SessionStorageUtil.getCurrentSemesterId();

    const handleCancel = () => {
        modalRef.current.close();
    };

    const handleWithdrawal = () => {
        if (checked) {
            dispatch(
                actionUserInfoWithdrawal({
                    data: {
                        userId,
                        semesterId,
                    },
                    callback,
                }),
            );
        } else {
            popupRef.current.openAlert('회원 탈퇴에 동의해 주세요.');
        }
    };

    return (
        <section>
            <div className='toast withdrawal fade show'>
                <div className='toast-body'>
                    <div className='error-inner withdrawal'>
                        <span className='ico-error'></span>
                        <div className='error-msg-tit'>탈퇴 하시겠습니까?</div>
                        <p className='info-icon-txt'>아래의 안내 사항을 꼭 확인해주세요.</p>
                        <ul className='explain-txt'>
                            <li>다시 가입이 제한될 수 있으며, 데이터는 복구할 수 없습니다.</li>
                            <li>탈퇴 후 회원정보는 모두 삭제됩니다.</li>
                            <li>탈퇴 후에도 커뮤니티(게시판) 서비스에 등록한 게시물은 그대로 남아 있습니다.</li>
                            <li>삭제를 원하는 게시물은 탈퇴 전 삭제처리하시기 바랍니다.</li>
                        </ul>
                        <div className='notice-check'>
                            <CheckBox
                                checked={checked}
                                onChecked={setChecked}
                                span='안내 사항을 확인하였으며, 이에 동의합니다.'
                            />
                        </div>
                    </div>
                </div>
                <div className='toast-foot btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <RedBgButtonBox title='탈퇴' btnPopup redbg onClick={(e) => handleWithdrawal()} />
                </div>
            </div>
            <div className='toast-back fade show'></div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default UserWithdrawalModal;
